import styled from 'styled-components';

import { MpParagraph } from 'shared/ui/MpParagraph';

const OlStyled = styled.ol`
	gap: 12px;
	display: flex;
	flex-direction: column;
	padding-left: 18px;
`;

const LiStyled = styled.li`
	margin: 0;
	@media (min-width: ${props => props.theme.breakpoints.xs}) {
		font-size: 14px;
	}

	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		font-size: 16px;
	}

	@media (min-width: ${props => props.theme.breakpoints.md}) {
		font-size: 16px;
	}

	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		font-size: 16px;
	}

	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		font-size: 16px;
	}

	@media (min-width: ${props => props.theme.breakpoints.xxl}) {
		font-size: 16px;
	}
`;

const SectionStyled = styled.section``;

const ImgStyled = styled.img`
	margin-bottom: 24px;
	@media (min-width: ${props => props.theme.breakpoints.xs}) {
		width: 328px;
	}

	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		width: 496px;
	}

	@media (min-width: ${props => props.theme.breakpoints.md}) {
		width: 508px;
	}

	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		width: 446px;
	}

	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		width: 446px;
	}

	@media (min-width: ${props => props.theme.breakpoints.xxl}) {
		width: 446px;
	}
`;

// eslint-disable-next-line @typescript-eslint/naming-convention
export const FlashlightInstruction_eng = (): JSX.Element => (
	<SectionStyled>
		<OlStyled>
			<LiStyled>Install the bot via marketplace</LiStyled>
			<LiStyled>Go to the bot in Telegram</LiStyled>
			<LiStyled>Click the «Start» button to subscribe to notifications</LiStyled>
			<LiStyled>Done, stay tuned for more news</LiStyled>
		</OlStyled>
		<MpParagraph>
			Add a bot to chat with your friends and send the command <b>/start@dodo1000bot</b> to have fun together for
			each new Dodo brands restaurant:
		</MpParagraph>
		<ImgStyled src='https://cdn.dodostatic.net/static/marketplace/flashlight/instruction-1' />
		<MpParagraph>Or opening a new country on the network:</MpParagraph>
		<ImgStyled src='https://cdn.dodostatic.net/static/marketplace/flashlight/instruction-2' />
	</SectionStyled>
);
